// extracted by mini-css-extract-plugin
export default {"SubMenu":"styles_SubMenu__wlYxK","onTop":"styles_onTop__fgVu2","option":"styles_option__cjz-8","selected":"styles_selected__DWhgt"};